export default __webpack_public_path__ + "static/media/adi_logo.8b42b97b.png";